import React, { Component } from 'react'
import { Form, Input } from 'antd'
import styled from 'styled-components'

const FormItem = Form.Item
const propTypes = {}
const AddItemArea = styled.div`
  padding: 15px;
  background-color: #f7f7f7;
`

class VendorAddressForm extends Component {
  componentDidUpdate(prevProps) {
    if (prevProps.contentData !== this.props.contentData) {
      this.props.form.setFieldsValue(this.props.contentData)
    }
  }
  handleCreate = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }

      this.props.addAddress(values)
    })
  }
  handleUpdate = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }

      this.props.saveAddress(values)
    })
  }
  render() {
    const { getFieldDecorator } = this.props.form
    const { contentData, isDisabled } = this.props
    return (
      <div className="addressForm">
        <AddItemArea>
          <Form layout="vertical">
            <div className="row">
              <div className="col-md-12">
                <FormItem label="Zip">
                  {getFieldDecorator('zip', {
                    rules: [
                      {
                        required: true,
                        message: 'ZIP cannot be blank.'
                      }
                    ],
                    initialValue: contentData ? contentData.zip : ''
                  })(<Input disabled={isDisabled} />)}
                </FormItem>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <FormItem label="Street Address">
                  {getFieldDecorator('address1', {
                    rules: [
                      {
                        required: true,
                        message: 'Street address cannot be blank.'
                      }
                    ],
                    initialValue: contentData ? contentData.address1 : ''
                  })(<Input placeholder="Enter address..." disabled={isDisabled} />)}
                </FormItem>
              </div>
              <div className="col-md-6">
                <FormItem label="Apt/Suite/Floor/Etc.">
                  {getFieldDecorator('address2', {
                    initialValue: contentData ? contentData.address2 : ''
                  })(<Input placeholder="Enter Apt/Suite/Floor/Etc..." disabled={isDisabled} />)}
                </FormItem>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <FormItem label="City">
                  {getFieldDecorator('city', {
                    rules: [
                      {
                        required: true,
                        message: 'City cannot be blank.'
                      }
                    ],
                    initialValue: contentData ? contentData.city : ''
                  })(<Input placeholder="Type in the city..." disabled={isDisabled} />)}
                </FormItem>
              </div>
              <div className="col-md-6">
                <FormItem label="State">
                  {getFieldDecorator('state', {
                    rules: [
                      {
                        required: true,
                        message: 'State cannot be blank.'
                      }
                    ],
                    initialValue: contentData ? contentData.state : ''
                  })(<Input placeholder="Type in state address..." disabled={isDisabled} />)}
                </FormItem>
              </div>
            </div>
          </Form>
        </AddItemArea>
      </div>
    )
  }
}

VendorAddressForm.propTypes = propTypes
export default Form.create()(VendorAddressForm)



// WEBPACK FOOTER //
// ./src/components/VendorAddressForm.js